import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Car } from "lucide-react";

export const VeiculoSugestao = ({ matricula, onUsar }) => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    setInfo(null);
    if ((matricula || "").replace(/[^A-Z0-9]/gi, "").length < 6) { return undefined; }
    const t = setTimeout(() => {
      api.get(`/veiculos/por-matricula/${encodeURIComponent(matricula)}`)
        .then((r) => setInfo(r.data.veiculo ? r.data : null)).catch(() => setInfo(null));
    }, 300);
    return () => { clearTimeout(t); };
  }, [matricula]);

  if (!info) return null;
  const v = info.veiculo;
  const desc = [v.marca, v.modelo, v.motorizacao].filter(Boolean).join(" ") || "sem marca/modelo";
  return (
    <div className="mt-2 flex items-center gap-3 flex-wrap rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid="veiculo-sugestao">
      <Car size={15} className="shrink-0" />
      <span className="flex-1 min-w-[200px]">
        Esta matrícula já existe: <b data-testid="veiculo-sugestao-desc">{desc}</b>
        {info.ultimo_cliente && <> · último cliente <b data-testid="veiculo-sugestao-cliente">{info.ultimo_cliente.nome}</b></>}
        {info.pedidos > 0 && <> · {info.pedidos} pedido(s)</>}
      </span>
      <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => onUsar(v, null)} data-testid="veiculo-sugestao-usar">Usar dados</Button>
      {info.ultimo_cliente && (
        <Button size="sm" className="h-7 text-xs bg-amber-600 hover:bg-amber-700" onClick={() => onUsar(v, info.ultimo_cliente)} data-testid="veiculo-sugestao-usar-cliente">Usar dados + cliente</Button>
      )}
    </div>
  );
};
